import { Card, CardContent, Stack } from "@bvhi/ui-base";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  elevation?: number;
}

export function ActionCard({ children, elevation }: Props) {
  return (
    <Card
      elevation={elevation ?? 1}
      sx={{
        position: "sticky",
        bottom: (theme) => theme.spacing(2),
        zIndex: (theme) => theme.zIndex.appBar - 1,
        top: (theme) => theme.spacing(10),
        transition: "box-shadow 0.3s ease",
      }}
    >
      <CardContent restrictContentWidth={false}>
        <Stack direction="row" justifyContent="end" spacing={2}>
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
}
